<template>
  <b-card style="padding:40px;">
    <h5><b>STOCKOUT BY DAY</b></h5>
    <hr />
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Full Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Date</label>
          <b-form-input
            v-model="form.date"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Company Name</label>
          <b-form-input
            v-model="form.company"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Roles</label>
          <b-form-input
            v-model="form.role"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Outlet Category</label>
          <b-form-input
            v-model="form.outlet_cat"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Outlet Name</label>
          <b-form-input
            v-model="form.outlet_name"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-size`">Product Type</label>
          <b-form-input
            v-model="form.type"
            id="input-horizontal"
            type="text"
            required
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Chiller</label>
          <b-form-radio-group
            v-model="form.chiller"
            :options="chiller"
            plain
            disabled
            name="plain-inline"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <TableStockout :grand="grandP" :fields="fields" :items="items" />
  </b-card>
</template>

<script>
import TableStockout from "@/table/user/subDealer/TableStockout";

export default {
  data() {
    return {
      grandP: "",
      items: [],
      form: {
        name: "",
        date: "",
        company: "",
        role: "",
        outlet_cat: "",
        outlet_name: "",
        type: "",
        chiller: ""
      },

      // Chiller
      chiller: [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" }
      ],

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Price (RM)",
          key: "price",
          sortable: false
        }
      ]
    };
  },
  created() {
    this.showStockout();
    this.form.type =
      parseInt(this.$route.query.pro_cat) === 1 ? "UHT" : "Pasteurized";
  },
  methods: {
    showStockout() {
      this.$store
        .dispatch("showStockout", {
          category: this.$route.query.cat,
          stock_id: this.$route.query.id
        })
        .then(res => {
          let price = 0;
          if (res.data.response.code === 100) {
            this.form.id = this.$route.query.id;
            this.form.name = res.data.data.userdetails.name;
            this.form.date = res.data.data.date;
            this.form.company = res.data.data.userdetails.company;
            this.form.role = res.data.data.userdetails.role_details.desc;
            this.form.outlet_cat = res.data.data.outlet.name;
            this.form.outlet_name = res.data.data.outlet_name;
            this.form.chiller = res.data.data.chiller;

            res.data.data.pro_stock.forEach(element => {
              let defPrice = parseFloat(element.price);
              price += defPrice;
              this.items.push({
                name: element.product.name,
                sku: element.product_id,
                quantity: element.quantity,
                price: element.price
              });
            });
            this.grandP = price;
          }
        });
    }
  },
  components: {
    TableStockout
  }
};
</script>
<style lang="css" scoped></style>
